import type { League } from "../types";

interface HeaderProps {
  league: League | null;
  onLeagueChange: (league: League | null) => void;
}

const LEAGUES: { value: League; label: string; dot: string }[] = [
  { value: "great",  label: "Great",  dot: "bg-blue-500"   },
  { value: "ultra",  label: "Ultra",  dot: "bg-yellow-500" },
  { value: "master", label: "Master", dot: "bg-purple-500" },
];

export default function Header({ league, onLeagueChange }: HeaderProps) {
  return (
    <header className="flex-shrink-0 flex items-center justify-between px-4 sm:px-6 min-h-14 pt-safe border-b border-white/[0.06] bg-scout-bg/80 backdrop-blur-md z-10">
      {/* Logo */}
      <div className="flex items-center gap-2.5">
        <div className="w-7 h-7 rounded-full bg-scout-red flex items-center justify-center shadow-md">
          {/* Pokéball top half */}
          <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white" aria-hidden="true">
            <path d="M12 2a10 10 0 0 1 9.95 9H14.9a3 3 0 0 0-5.8 0H2.05A10 10 0 0 1 12 2zm0 20a10 10 0 0 1-9.95-9h7.05a3 3 0 0 0 5.8 0h7.05A10 10 0 0 1 12 22z" />
          </svg>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="text-[15px] font-bold tracking-tight text-white">ScoutDex</span>
          <span className="text-[10px] font-semibold tracking-wide text-white/30 bg-white/[0.06] border border-white/[0.10] rounded px-1.5 py-0.5 leading-none select-none">beta</span>
        </div>
      </div>

      {/* League filter pills */}
      <nav className="flex items-center gap-0.5" aria-label="League filter">
        <button
          onClick={() => onLeagueChange(null)}
          className={`px-2 py-1 rounded-full text-xs font-medium transition-all ${
            league === null
              ? "bg-white/10 text-white"
              : "text-white/40 hover:text-white/70 hover:bg-white/5"
          }`}
        >
          All
        </button>
        {LEAGUES.map((l) => (
          <button
            key={l.value}
            onClick={() => onLeagueChange(l.value)}
            className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium transition-all ${
              league === l.value
                ? "bg-white/10 text-white"
                : "text-white/40 hover:text-white/70 hover:bg-white/5"
            }`}
          >
            <span className={`w-1.5 h-1.5 rounded-full ${l.dot}`} />
            {l.label}
          </button>
        ))}
      </nav>
    </header>
  );
}

